import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {CustomWishlistAdapter} from './whislist.adapter';
import {Wishlist} from '../wishlist.model';

@Injectable({
  providedIn: 'root',
})
export class WishListConnector {
  constructor(protected adapter: CustomWishlistAdapter) {}

  public loadWishlist(userId: string): Observable<Wishlist> {
    return this.adapter.loadWishlist(userId);
  }

  public createWishlist(
    userId: string,
    productCode?: string,
  ): Observable<Wishlist> {
    return this.adapter.createWishlist(userId, productCode);
  }

  public deleteWishlist(userId: string, productCode: string): Observable<any> {
    return this.adapter.deleteWishlist(userId, productCode);
  }
}
